export const QUESTIONNAIRE_IN_PROGRESS_URL_SEARCH_PARAM = 'inProgress';
export const SIGNUP_TYPE_URL_SEARCH_PARAM = 'type';
